<template>
  <el-table-column
    prop="is_available_for_representatives"
    sortable="custom"
    label="Képviselő rendelheti"
    show-overflow-tooltip
    min-width="180"
  >
    <template slot-scope="scope">
      <el-tag
        v-if="scope.row.is_available_for_representatives"
        size="small"
        type="success"
      >
        Igen
      </el-tag>
      <el-tag
        v-if="!scope.row.is_available_for_representatives"
        size="small"
        type="danger"
      >
        Nem
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'is_available_for_representatives',
};
</script>
